










































import { Input } from 'element-ui'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'CustomInput',
  inheritAttrs: false,
  components: { [Input.name]: Input },
})
export default class CustomInput extends Vue {
  @Prop({ default: '' })
  readonly value!: string | number | null

  @Prop({ default: '' })
  readonly label!: string

  @Prop({ default: '' })
  readonly customClass!: string

  isFocused = false

  get hasValue(): boolean {
    return !(
      this.value === '' ||
      this.value === null ||
      this.value === undefined
    )
  }

  get hasUserPrefix(): boolean {
    return (
      Boolean(this.$slots.prefix) ||
      this.$attrs['prefix-icon'] !== undefined ||
      (this.$attrs as any).prefixIcon !== undefined
    )
  }

  get mergedListeners() {
    const l = this.$listeners as Record<string, any>
    return {
      ...l,
      input: (val: any) => {
        this.$emit('input', val)
        if (typeof l.input === 'function') {
          l.input(val)
        }
      },
      focus: (e: FocusEvent) => {
        this.isFocused = true
        if (typeof l.focus === 'function') {
          l.focus(e)
        }
      },
      blur: (e: FocusEvent) => {
        this.isFocused = false
        if (typeof l.blur === 'function') {
          l.blur(e)
        }
      },
    }
  }

  get input(): any {
    return this.$refs.input
  }
  focus() {
    this.input && this.input.focus && this.input.focus()
  }
  blur() {
    this.input && this.input.blur && this.input.blur()
  }
  select() {
    this.input && this.input.select && this.input.select()
  }
}
